"use client";

import { useState } from "react";
import { HiringTopBar } from "@/components/demos/hiring/HiringTopBar";
import { HiringHero } from "@/components/demos/hiring/HiringHero";
import { HiringPracticesSection } from "@/components/demos/hiring/HiringPracticesSection";
import { HiringTrustSection } from "@/components/demos/hiring/HiringTrustSection";
import { RequisitionProposalModal } from "@/components/demos/hiring/RequisitionProposalModal";
import { EXECUTIVE_PRACTICES } from "@/lib/demos/hiringData";

export default function HiringPortalPage() {
  const [currency, setCurrency] = useState<"INR" | "USD">("INR");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPracticeId, setSelectedPracticeId] = useState("c-suite");
  const [targetCtc, setTargetCtc] = useState<number | undefined>(undefined);
  const [isResetting, setIsResetting] = useState(false);

  async function handleResetDemo() {
    setIsResetting(true);
    try {
      await fetch("/api/demos/hiring/reset", { method: "POST" });
    } catch (err) {
      console.error("[Reset Demo Error]", err);
    } finally {
      setIsResetting(false);
    }
  }

  function handleOpenSearchFromHero(data: {
    practiceId: string;
    targetCtc: number;
    placementFee: number;
  }) {
    setSelectedPracticeId(data.practiceId);
    setTargetCtc(data.targetCtc);
    setIsModalOpen(true);
  }

  function handleSelectPractice(practiceId: string) {
    setSelectedPracticeId(practiceId);
    const p = EXECUTIVE_PRACTICES.find((x) => x.id === practiceId);
    if (p) {
      const def = currency === "USD" ? p.rolesBenchmarkUsd.default : p.rolesBenchmarkInr.default;
      setTargetCtc(def);
    }
    setIsModalOpen(true);
  }

  return (
    <main className="min-h-screen flex flex-col bg-[#0a0710]">
      {/* Top Header Bar */}
      <HiringTopBar
        currency={currency}
        onCurrencyToggle={setCurrency}
        onResetDemo={handleResetDemo}
        isResetting={isResetting}
      />

      {/* Hero with Interactive Fee Calculator */}
      <HiringHero
        currency={currency}
        onRequestSearch={handleOpenSearchFromHero}
      />

      {/* Practice Domains Section */}
      <HiringPracticesSection
        currency={currency}
        onSelectPractice={handleSelectPractice}
      />

      {/* Managing Partners & Guarantees Trust Section */}
      <HiringTrustSection />

      {/* Interactive Mandate Requisition Modal */}
      <RequisitionProposalModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currency={currency}
        initialPracticeId={selectedPracticeId}
        initialCtc={targetCtc}
      />

      {/* Footer */}
      <footer className="py-8 bg-[#07040b] border-t border-purple-950/60 text-center text-xs text-slate-500">
        <p>
          Nexus Executive Search &amp; Talent Partners • Powered by{" "}
          <span className="text-purple-400 font-semibold">Johnson Softwares</span>
        </p>
      </footer>
    </main>
  );
}
